/*
  cs-variant-media.js — makes the PDP image swap feel instant.

  Dawn changes variants by fetching the whole section back from the Section
  Rendering API and only then swapping the gallery. Measured on this store that
  round-trip is ~358ms of a ~390ms swap, so the picture sits still for a third of
  a second after the tap even though the media it needs is usually ALREADY in the
  gallery markup.

  This does two things, both additive — Dawn's own logic still runs and still has
  the final say on price, availability and any media it needs to add:

    1. Warms the gallery. Only the first image is eager, so the first swap to any
       other colour also waited on an image download. After first paint the rest
       are fetched and decoded, off the critical path.

    2. Swaps optimistically. On a variant click we look up that variant's
       featured media and, if it is already in the gallery, activate it right
       away rather than waiting for the network.

  If anything is missing — no map, unknown variant, media not in the DOM — this
  does nothing at all and the stock Dawn path is what you get.
*/
(function () {
  var root = document.querySelector('[data-cs-variant-media]');
  if (!root) return;

  var map;
  try {
    map = JSON.parse(document.querySelector('[data-cs-variant-media-map]').textContent);
  } catch (e) {
    return; // no usable map: leave Dawn alone
  }

  var sectionId = root.getAttribute('data-cs-variant-media');

  /*
    Deliberately NOT resolved here. main-product loads media-gallery.js AFTER
    this file and both are deferred, so at this point <media-gallery> is still an
    un-upgraded element and setActiveMedia does not exist yet. Checking for it
    during init silently disabled the whole script. Resolve it at click time,
    by which point the element has been upgraded.
  */
  function galleryEl() {
    var g = root.querySelector('media-gallery');
    return g && typeof g.setActiveMedia === 'function' ? g : null;
  }

  /* --- 1. warm the gallery, but only for someone who looks like they will use it ---

     Warming on idle cost every visitor the full gallery up front (measured ~700KB
     of not-yet-visible images on the 8-image beach chair) including the majority
     who never change colour. Instead this waits for the first hover or keyboard
     focus on the colour picker: that is hundreds of milliseconds ahead of the
     click, which is all the head start the swap needs, and it costs nothing for
     visitors who never touch it. Runs once. */
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    root.querySelectorAll('media-gallery li[data-media-id] img').forEach(function (img) {
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      if (!img.complete && img.decode) img.decode().catch(function () {});
    });
  }
  var picker = root.querySelector('variant-selects');
  if (picker) {
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (evt) {
      picker.addEventListener(evt, warm, { once: true, passive: true });
    });
  }

  // --- 2. swap the visible media on click, ahead of the section fetch ---
  root.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.name) return;

      // Read the variant this click produces from the picker's own state.
      var form = input.closest('variant-selects');
      if (!form) return;

      var chosen = Array.prototype.map
        .call(form.querySelectorAll('input[type="radio"]:checked, select'), function (el) {
          return el.value;
        })
        .join(' / ');

      var mediaId = map[chosen];
      if (!mediaId) return;

      var domId = sectionId + '-' + mediaId;
      if (!root.querySelector('media-gallery [data-media-id="' + domId + '"]')) return;

      warm();
      var gallery = galleryEl();
      if (!gallery) return;
      gallery.setActiveMedia(domId, true);
    },
    true // capture, so this runs before Dawn's own change handler kicks off the fetch
  );
})();
